import { Decimal } from "decimal.js";

const format = (value, fallback, precision, unit) => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  return `${Decimal(value).toFixed(precision)} ${unit}`;
};

export const formatVolume = (value, fallback = "-") => format(value, fallback, 1, "m³");

// Number of decimal places needed to represent a step value (e.g. 0.05 -> 2, 0.5 -> 1).
// Minimum of 1 so volume inputs always show at least one decimal.
export const decimalPlaces = (value) => {
  const str = String(value);
  const idx = str.indexOf(".");
  const decimals = idx === -1 ? 0 : str.length - idx - 1;
  return Math.max(decimals, 1);
};

export const formatMass = (value, fallback = "-") => format(value, fallback, 3, "kg/m³");

export const formatWeight = (value, fallback = "-", unit = "kg") => format(value, fallback, 2, unit);

export const formatPercentual = (value, fallback = "-") => format(Decimal.mul(value, 100), fallback, 2, "%");

const pad2 = (n) => String(n).padStart(2, "0");

export const formatElapsedMs = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hh = Math.floor(totalSeconds / 3600);
  const mm = Math.floor((totalSeconds % 3600) / 60);
  const ss = totalSeconds % 60;

  return hh > 0
    ? `${pad2(hh)}:${pad2(mm)}:${pad2(ss)}`
    : `${pad2(mm)}:${pad2(ss)}`;
};
